
import { Link } from "react-router-dom";


const title = "Coming Soon";
const desc = "Website is under Maintanance";
const btnText = "Go Back To Home";




const ErrorPage = () => {
    return ( 
        <div className="four-zero-section padding-tb section-bg">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-sm-6 col-12">
                        <div className="four-zero-content">
                            <Link to="/">
                                
                            </Link>
                            <h2 className="title">{title}</h2>
                            <p>{desc}</p>
                                                    </div>
                    </div>
                    <div className="col-lg-8 col-sm-6 col-12">
                        <div className="foue-zero-thumb">
                            <img src="assets/images/404.png" alt="CodexCoder" />
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    );
}

export default ErrorPage;